import { Feature } from "components/feature";
import * as React from "react";
import * as ReportConstants from "../constants";
import { CustomReports } from "./custom-reports";
import { FranchiseRoyalties } from "./franchise-royalties";
import { OutstandingInvoices } from "./outstanding-invoices";
import { ReferralSource } from "./referral-source";
import { Referrals } from "./referrals";
import { ClientPlacementRevenue } from "./revenue";
import { StageConversion } from "./stage-conversion";
import { Summary } from "./summary";

interface Props {
    reportName: ReportConstants.ReportNames;
}

export const ReportsShow: React.FC<Props> = props => {
    const reportName = props.reportName;

    if (reportName === "summary") {
        return (
            <Feature name="placement">
                <Summary />
            </Feature>
        );
    }

    if (reportName === "revenue") {
        return (
            <Feature name="placement">
                <ClientPlacementRevenue />
            </Feature>
        );
    }

    if (reportName === "inbound-referrals" || reportName === "referrals") {
        return (
            <Feature name="placement">
                <Referrals />
            </Feature>
        );
    }

    if (reportName === "referral-source") {
        return (
            <Feature name="placement">
                <Feature name="referralSourceReport">
                    <ReferralSource />
                </Feature>
            </Feature>
        );
    }

    if (reportName === "custom") {
        return <CustomReports />;
    }

    if (reportName === "stage-conversion") {
        return (
            <Feature name="stageConversion">
                <StageConversion />
            </Feature>
        );
    }

    if (reportName === "franchise-royalties") {
        return (
            <Feature name="franchiseManagement">
                <FranchiseRoyalties />
            </Feature>
        );
    }

    if (reportName === "outstanding-invoices") {
        return (
            <Feature name="outstandingInvoicesReport">
                <OutstandingInvoices />
            </Feature>
        );
    }

    return <h2>Sorry, no report found</h2>;
};
